// extracted by mini-css-extract-plugin
export default {"container":"FilterChip_container__qoPOo","iconContainer":"FilterChip_iconContainer__EqiL4","closeButton":"FilterChip_closeButton__ujOyl"};